/* eslint-disable react/prop-types */
import { Suspense, useCallback, useState } from "react";
import CustomInput from "../CustomInput/CustomInput";
import { maskedSSN } from "../../../constants/maskSSN";
import { IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { api } from "../../../utils/api";
import { trackPromise } from "react-promise-tracker";

const DynamicInformationForm = ({ informationFormData, idAndRole }) => {
	const [showSSN, setShowSSN] = useState(false);
	// eslint-disable-next-line arrow-parens
	// const toggleSSN = () => setShowSSN((prev) => !prev);

	console.log("informationFormData", informationFormData);

	const toggleSSN = useCallback(async () => {
		if (informationFormData.length === 0) return;

		try {
			if (!showSSN) {
				const viewSSNAddLogPayload = {
					member_id: idAndRole.id,
					member_role: idAndRole?.role
				};
				// console.log("gender toggling", viewSSNAddLogPayload);
				// // console.log(member);
				const response = await trackPromise(api.SSN.viewSSNAddLog(viewSSNAddLogPayload));

				// // handle the response
				// console.log(response, "response");
				if (response) {
					// eslint-disable-next-line arrow-parens
					setShowSSN((prev) => !prev);
				}
			} else {
				// eslint-disable-next-line arrow-parens
				setShowSSN((prev) => !prev);
			}
		} catch (error) {
			console.error("Something Went Wrong,Please try again!", error);
		}
	}, [idAndRole, informationFormData.length, showSSN]);

	return (
		<div
			className="dynamic-information-form-container"
			id="dynamic-information-form-container"
			style={{ marginTop: "2rem" }}
		>
			{informationFormData &&
				informationFormData.map((eachItem, index) => {
					const { label, name, value } = eachItem;
					const isSSN = name === "SSN";
					return (
						<div className="details-form-row" key={index}>
							<div className="details-form-label">
								{label}{" "}
								{isSSN && (
									<IconButton onClick={toggleSSN} style={{ marginLeft: "8px" }} size="small">
										{!showSSN ? <VisibilityOff /> : <Visibility />}
									</IconButton>
								)}
							</div>
							<Suspense fallback={<div />}>
								<CustomInput
									name={name}
									value={name == "SSN" && !showSSN ? maskedSSN(value) : value}
									disabled={true}
								/>
							</Suspense>
						</div>
					);
				})}
		</div>
	);
};

export default DynamicInformationForm;
